import { actionTypes } from '../actions/types';

const initState = {
  isLoading: false,
  all: null,
  chosen: null,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_EXPERIMENTS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCHED_EXPERIMENTS:
      return {
        ...state,
        isLoading: false,
        all: action.data,
        error: null,
      };
    case actionTypes.CHOSEN_EXPERIMENTS:
      return {
        ...state,
        chosen: {
          ...state.chosen,
          ...action.data,
        },
      };
    default:
      return state;
  }
};
